import { Alert, Space } from 'antd';
import { VATBreakdown } from '@/utils/vat';
import { formatCurrency, formatVATRate, formatCountryCode } from '@/utils/currency';

interface VATPreviewProps {
  vatBreakdown: VATBreakdown | null;
}

/**
 * VAT breakdown preview component
 * Shows Net Amount, VAT (rate + amount), and Gross Amount
 */
export function VATPreview({ vatBreakdown }: VATPreviewProps) {
  if (!vatBreakdown) {
    return (
      <Alert
        type="info"
        message="VAT Calculation"
        description="Select country and enter amount to see VAT breakdown"
        showIcon
      />
    );
  }

  const { netAmount, vatRate, vatAmount, grossAmount, customerCountry } = vatBreakdown;

  return (
    <Alert
      type="success"
      message={`VAT Breakdown - ${formatCountryCode(customerCountry, true)}`}
      description={
        <Space direction="vertical" size={4} style={{ width: '100%' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>Net Amount:</span>
            <strong>{formatCurrency(netAmount)}</strong>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>VAT ({formatVATRate(vatRate)}):</span>
            <strong>{formatCurrency(vatAmount)}</strong>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              paddingTop: 8,
              borderTop: '1px solid #d9d9d9',
              marginTop: 4,
            }}
          >
            <span>
              <strong>Gross Amount:</strong>
            </span>
            <strong style={{ fontSize: '16px' }}>{formatCurrency(grossAmount)}</strong>
          </div>
        </Space>
      }
      showIcon
    />
  );
}
